import { Button } from "@mui/material";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { useCollectionRow } from "@/store/useCollectionsCompute";

export default function RedirectNotification() {
  const navigate = useNavigate();
  const params = new URLSearchParams(window.location.search);
  const feedId = params.get("feedId");
  const itemId = params.get("itemId");

  const feedRecord = useCollectionRow("feed", feedId);

  useEffect(() => {
    if (!feedRecord) return;

    const hash = itemId ? `#${itemId}` : "";

    if (feedRecord.aliasMembershipId) {
      window.location.href = `/workspaces/${feedRecord.workspaceId}/drivers/${feedRecord.aliasMembershipId}/channel/${feedRecord.id}${hash}`;
    } else {
      window.location.href = `/workspaces/${feedRecord.workspaceId}/channels/${feedRecord.id}${hash}`;
    }
  }, [feedRecord, itemId]);

  return <Button onClick={() => navigate("/workspaces/")}>Home</Button>;
}
